module.exports = __webpack_public_path__ + "static/four-steps-turorial-step-3-3465dfdd690371029018ecbf390ead78.svg";